enum HyperMediaType {
  LIST = 'list',
  OBJECT = 'object',
}

export default HyperMediaType;
